import { mixed, object, string } from 'yup';

import { buildRichTextSchema, TEXT_AREA_MAX_LENGTH } from '../../../../common';
import { CRISIS_PLAN_RICH_TEXT_MIN_LENGTH } from './constants';

import type { Moment } from 'moment';

const CRISIS_PLAN_RICH_TEXT_SCHEMA = buildRichTextSchema({
  minLength: CRISIS_PLAN_RICH_TEXT_MIN_LENGTH,
  maxLength: TEXT_AREA_MAX_LENGTH,
  minMessage: `Must be at least ${CRISIS_PLAN_RICH_TEXT_MIN_LENGTH} characters`,
  maxMessage: `Must be at most ${TEXT_AREA_MAX_LENGTH} characters`,
});

export const CRISIS_PLAN_FORM_SCHEMA = object({
  assessment_behavior_id: string().defined(),
  crisis_creation_date: mixed<Moment>().nullable().required(),
  operational_definition: CRISIS_PLAN_RICH_TEXT_SCHEMA,
  antecedent_interventions: CRISIS_PLAN_RICH_TEXT_SCHEMA,
  precursors_action_steps: CRISIS_PLAN_RICH_TEXT_SCHEMA,
  escalation_intervention_plan: CRISIS_PLAN_RICH_TEXT_SCHEMA,
  follow_up_steps: CRISIS_PLAN_RICH_TEXT_SCHEMA,
  functional_behavior: string().required(),
  consequence_strategies: CRISIS_PLAN_RICH_TEXT_SCHEMA,
});

export function createCrisisPlanFormSchema(requireRelatedBehavior: boolean) {
  if (!requireRelatedBehavior) return CRISIS_PLAN_FORM_SCHEMA;
  return CRISIS_PLAN_FORM_SCHEMA.shape({
    assessment_behavior_id: string().required(),
  });
}
